// This is equal to palette.grey.shade30 and greys.50, but we want to keep the editor styling independent of app styling.
const editorBlockquoteColor = '#bbbdbf';

export function makeBlockquoteStyle(color: string) {
  return `margin: 0 0 0 7px; border-left: 3px solid ${color}; padding-left: 10px;`;
}

export const blockquoteStyle = makeBlockquoteStyle(editorBlockquoteColor);
